<template>
  <div class="edu-team-area ptb-100">
    <div class="container">
      <div class="edu-section-title">
        <p class="sub-title">Takım Üyeleri</p>
        <h2>Uzman <span class="shape02">Eğitmenlerimiz</span></h2>
      </div>
      <div class="row justify-content-center">
        <div v-for="member in teamMembers" :key="member.id" class="col-lg-3 col-md-6 col-sm-12">
          <div class="single-team-box02">
            <!-- RESİM TIKLANABİLİR -->
            <div class="image image-wrapper">
              <router-link :to="{ name: 'InstructorDetailsPage', params: { id: member.id } }">
                <img :src="member.image" :alt="member.name" class="team-image" />
              </router-link>
              <div class="social-links">
                <div class="hover-social">
                  <ul>
                    <li v-if="member.socials?.facebook">
                      <a :href="member.socials.facebook" class="sg-1" target="_blank" rel="noopener">
                        <i class="bx bxl-facebook"></i>
                      </a>
                    </li>
                    <li v-if="member.socials?.twitter">
                      <a :href="member.socials.twitter" class="sg-2" target="_blank" rel="noopener">
                        <i class="bx bxl-twitter"></i>
                      </a>
                    </li>
                    <li v-if="member.socials?.linkedin">
                      <a :href="member.socials.linkedin" class="sg-3" target="_blank" rel="noopener">
                        <i class="bx bxl-linkedin"></i>
                      </a>
                    </li>
                    <li v-if="member.socials?.instagram">
                      <a :href="member.socials.instagram" class="sg-4" target="_blank" rel="noopener">
                        <i class="bx bxl-instagram"></i>
                      </a>
                    </li>
                  </ul>
                  <i class="bx bx-plus"></i>
                </div>
              </div>
            </div>

            <!-- İSİM DE TIKLANABİLİR -->
            <div class="content">
              <h3>
                <router-link :to="{ name: 'InstructorDetailsPage', params: { id: member.id } }">
                  {{ member.name }}
                </router-link>
              </h3>
              <p>{{ member.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import teamMembers from "@/data/teamData";

export default {
  name: "TeamMembers",
  data() {
    return {
      teamMembers,
    };
  },
};
</script>

<style scoped>
.image-wrapper {
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  border-radius: 12px;
  background: #f8f8f8;
}

.team-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  display: block;
}
</style>
